import SOLID_WATCH_OUTLINE from '../../../images/rating-solid-watch-outline.svg'
import NOT_MY_THING_OUTLINE from '../../../images/rating-not-my-thing-outline.svg'
import TOP_PICK_OUTLINE from '../../../images/rating-top-pick-outline.svg'
import SOLID_WATCH_FILLED from '../../../images/rating-solid-watch-filled.svg'
import NOT_MY_THING_FILLED from '../../../images/rating-not-my-thing-filled.svg'
import TOP_PICK_FILLED from '../../../images/rating-top-pick-filled.svg'

export const UserRatingScale = {
  NOT_MY_THING: 'NOT_MY_THING',
  SOLID_WATCH: 'SOLID_WATCH',
  TOP_PICK: 'TOP_PICK',
  UNRATED: 'UNRATED'
}
export const UserRatingLabel = {
  NOT_MY_THING: 'Nah',
  SOLID_WATCH: 'Ka pai',
  TOP_PICK: 'Sweet as'
}
export const PopoverCopyAfterRating = {
  NOT_MY_THING: `We'll recommend less like this`,
  SOLID_WATCH: `We'll recommend more like this`,
  TOP_PICK: `Awesome! We'll recommend more like this`
}

/**
 * for rate button on show page.
 * * if user hasn't rated(userRating = null), or has cleared rating(UNRATED), the icon should be SOLID_WATCH_OUTLINE;
 * * if user has rated one of the 3, icon should be `*__FILLED`
 * @param {*} userRating user's rating, check schema type `UserRating`
 * @returns {object} { ratingIcon, ratingLabel }
 */
export const getIconAndLabelForRateButton = userRating => {
  let ratingIcon = ''
  let ratingLabel = ''
  if (!userRating || userRating.ratingValue === UserRatingScale.UNRATED) {
    ratingLabel = 'RATE'
  } else {
    ratingLabel = 'RATED'
  }
  if (!userRating) {
    ratingIcon = SOLID_WATCH_OUTLINE
  } else {
    if (userRating.ratingValue === UserRatingScale.NOT_MY_THING) {
      ratingIcon = NOT_MY_THING_FILLED
    }
    if (userRating.ratingValue === UserRatingScale.SOLID_WATCH) {
      ratingIcon = SOLID_WATCH_FILLED
    }
    if (userRating.ratingValue === UserRatingScale.TOP_PICK) {
      ratingIcon = TOP_PICK_FILLED
    }
    if (userRating.ratingValue === UserRatingScale.UNRATED) {
      ratingIcon = SOLID_WATCH_OUTLINE
    }
  }
  return {
    ratingIcon,
    ratingLabel
  }
}

/**
 * for each rate option in the row that has 3 options (used on show page and player)
 * * when default scale matches user's rating, the icon should be `*_FILLED`, otherwise `*_OUTLINE`
 * @param {*} defaultScale 3 values of UserRatingScale (except UNRATED)
 * @param {*} userRating user's rating, check schema type `UserRating`
 * @returns {object} { ratingIcon, ratingLabel }
 */
export const getIconAndLabelForRateOption = (defaultScale, userRating) => {
  let ratingIcon = ''
  const ratingLabel = UserRatingLabel[defaultScale]
  // initial with the outline icon no matter userRating is feteched or not
  if (defaultScale === UserRatingScale.NOT_MY_THING) {
    ratingIcon = NOT_MY_THING_OUTLINE
  }
  if (defaultScale === UserRatingScale.SOLID_WATCH) {
    ratingIcon = SOLID_WATCH_OUTLINE
  }
  if (defaultScale === UserRatingScale.TOP_PICK) {
    ratingIcon = TOP_PICK_OUTLINE
  }
  // userRating fetched and use the filled image if it matches the default rating scale
  if (userRating?.ratingValue === defaultScale) {
    if (defaultScale === UserRatingScale.NOT_MY_THING) {
      ratingIcon = NOT_MY_THING_FILLED
    }
    if (defaultScale === UserRatingScale.SOLID_WATCH) {
      ratingIcon = SOLID_WATCH_FILLED
    }
    if (defaultScale === UserRatingScale.TOP_PICK) {
      ratingIcon = TOP_PICK_FILLED
    }
  }

  return {
    ratingIcon,
    ratingLabel
  }
}

/**
 * return the rating value to be used for mutation `updateUserRating`.
 * if clicked rating value is same as current user rating, we assume the intention is to unrate
 * @param {*} currentUserRating state `userRating`
 * @param {'NOT_MY_THING' | 'SOLID_WATCH' | 'TOP_PICK'} ratingValueClicked - ref to {@link UserRatingScale}
 * @returns one of values under enum `UserRatingScale`
 */
export const getRatingValueToUpdate = (
  currentUserRating,
  ratingValueClicked
) => {
  return ratingValueClicked === currentUserRating?.ratingValue
    ? UserRatingScale.UNRATED
    : ratingValueClicked
}

/**
 * display the popover with text from {@link PopoverCopyAfterRating} after rated good or bad; when unrated, hide the popover.
 * @param {'NOT_MY_THING' | 'SOLID_WATCH' | 'TOP_PICK' | 'UNRATED'} ratingValueToUpdate - ref to {@link UserRatingScale}
 */
export const shouldDisplayPopover = ratingValueToUpdate => {
  if (ratingValueToUpdate === UserRatingScale.UNRATED) {
    return {
      shouldDipslayPopover: false,
      popoverCopy: ''
    }
  }
  return {
    shouldDipslayPopover: true,
    popoverCopy: PopoverCopyAfterRating[ratingValueToUpdate]
  }
}
